import { Suspense, useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { BasicLoader } from 'components/loaders/basic-loader';
import { BaseRoute } from 'core/models/base-routes';
import { _noop } from 'utils/function.utils';

export const Router = observer<{
  routes: BaseRoute[];
  localStore?: Record<string, any>;
  styles?: { readonly [key: string]: string };
  onLoad?: (route: BaseRoute) => void;
}>(({ routes, localStore, styles, onLoad = _noop }) => {
  const onRouteHandle = (route: BaseRoute) => {
    onLoad(route);
  };

  return (
    <Routes>
      {routes.map((route, i) => {
        return route.canActivate === undefined || route.canActivate() ? (
          <Route
            key={i}
            path={route.path}
            element={
              <Suspense key={i} fallback={<BasicLoader isLoading={true}></BasicLoader>}>
                <RouteWrapper route={route} onLoad={onRouteHandle}>
                  <route.component {...route} localStore={localStore} styles={styles} />
                </RouteWrapper>
              </Suspense>
            }
          />
        ) : (
          <Route
            key={i}
            path={route.path}
            element={
              <Navigate
                to={{
                  pathname: '/',
                }}
              />
            }
          />
        );
      })}
    </Routes>
  );
});

const RouteWrapper = observer<{ route: BaseRoute; children: any; onLoad: (route: BaseRoute) => void }>(({ route, children, onLoad }) => {
  useEffect(() => {
    onLoad(route);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return children;
});